import { __extends } from "tslib";
// DS: UI07
/** A styled checkbox control for forms */
import React from 'react';
import classnames from 'classnames';
import BiSpan from '../biLogger/Components/BiSpan';
import Check from '../Icons/Check';
import s from './RoundCheckbox.scss';
// UI07 in DS
var RoundCheckbox = /** @class */ (function (_super) {
    __extends(RoundCheckbox, _super);
    function RoundCheckbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (event) {
            var _a = _this.props, onChange = _a.onChange, isChecked = _a.isChecked;
            if (onChange) {
                onChange(!isChecked, event);
            }
        };
        return _this;
    }
    RoundCheckbox.prototype.render = function () {
        var _a = this.props, className = _a.className, label = _a.label, isChecked = _a.isChecked, labelOnRight = _a.labelOnRight, forcedLightTheme = _a.forcedLightTheme, biData = _a.biData;
        return (React.createElement(BiSpan, { className: classnames(s['root'], className, isChecked && s['isChecked'], !labelOnRight && s['label-left'], labelOnRight && s['label-right'], forcedLightTheme && s['forced-light-theme']), onClick: this.onClick, biData: biData },
            !labelOnRight && label && React.createElement("span", { className: s['label'] }, label),
            React.createElement("span", { className: s['check-wrapper'] },
                React.createElement(Check, { className: s['check'], customSizable: true })),
            labelOnRight && label && React.createElement("span", { className: s['label'] }, label)));
    };
    return RoundCheckbox;
}(React.Component));
export { RoundCheckbox };
export default RoundCheckbox;
//# sourceMappingURL=RoundCheckbox.js.map